/*
 * Measurement units of the shopping list, kept out of the transifex files because they are short
 * technical labels that need a native eye rather than a translation pass.
 *
 * These are the units.json entries with translated=true, and only those: the parser yields their
 * locale-independent unitKey ("g", "tbsp", "cup"), so localizing them is up to us. The other units
 * (can, btl, box, clv...) are yielded as the word they were written in ("bouteille", "Dose") and
 * displayed as such — nothing to translate. See unitOutput() in lib/ingredientParser.ts.
 *
 * Per unit:
 *   name - standalone label, used by the chips of the quantity picker
 *   N    - how a quantity reads, ${.} being the number: "300g", "3 cups"
 *   1    - singular, only when the plural form does not read well for one ("1 cup")
 *
 * A language only declares what differs from root: symbols ("g", "ml") read the same everywhere, and
 * any missing unit or language falls back to English. What a language declares comes from units.json:
 * a unit with no form in that language is not parsed there either, so it is not localized here.
 */
const rootUnits = {
  //a bare count writes no unit at all: "4 onions", never "4 pc"
  "pc":{name:"pc"},
  "g":{name:"gr",N:"${.}g"},
  "kg":{name:"kg",N:"${.}kg"},
  "mg":{name:"mg",N:"${.}mg"},
  "ml":{name:"ml",N:"${.}ml"},
  "cl":{name:"cl",N:"${.}cl"},
  "dl":{name:"dl",N:"${.}dl"},
  "L":{name:"L",N:"${.}L"},
  "oz":{name:"oz",N:"${.} oz"},
  "fl oz":{name:"fl oz",N:"${.} fl oz"},
  "lb":{name:"lb",N:"${.} lb"},
  "tbsp":{name:"tbsp",N:"${.} tbsp"},
  "tsp":{name:"tsp",N:"${.} tsp"},
  "cup":{name:"cup",1:"1 cup",N:"${.} cups"}
};

//the litre is the one symbol that is not written the same everywhere: "L" in English, "l" elsewhere
const frUnits = {
  "pc":{name:"pièce"},
  "L":{name:"l",N:"${.}l"},
  "tbsp":{name:"c. à s.",N:"${.} c. à s."},
  "tsp":{name:"c. à c.",N:"${.} c. à c."},
  "cup":{name:"tasse",1:"1 tasse",N:"${.} tasses"}
};

const deUnits = {
  "pc":{name:"Stück"},
  "L":{name:"l",N:"${.}l"},
  "tbsp":{name:"EL",N:"${.} EL"},
  "tsp":{name:"TL",N:"${.} TL"},
  "cup":{name:"Tasse",1:"1 Tasse",N:"${.} Tassen"}
};

const esUnits = {
  "pc":{name:"unidad"},
  "L":{name:"l",N:"${.}l"},
  "tbsp":{name:"cda.",N:"${.} cda."},
  "tsp":{name:"cdta.",N:"${.} cdta."},
  "cup":{name:"taza",1:"1 taza",N:"${.} tazas"}
};

const nlUnits = {
  "pc":{name:"stuk"},
  "L":{name:"l",N:"${.}l"},
  "tbsp":{name:"el",N:"${.} el"},
  "tsp":{name:"tl",N:"${.} tl"},
  "cup":{name:"kop",1:"1 kop",N:"${.} koppen"}
};

//units.json knows no Italian cup, so "cup" stays English here as well
const itUnits = {
  "pc":{name:"pezzo"},
  "L":{name:"l",N:"${.}l"},
  "tbsp":{name:"cucchiaio",1:"1 cucchiaio",N:"${.} cucchiai"},
  "tsp":{name:"cucchiaino",1:"1 cucchiaino",N:"${.} cucchiaini"}
};

const svUnits = {
  "tbsp":{name:"msk",N:"${.} msk"},
  "tsp":{name:"tsk",N:"${.} tsk"}
};

const ptUnits = {
  "tbsp":{name:"colher de sopa",1:"1 colher de sopa",N:"${.} colheres de sopa"}
};

export default {
    // English is defined as "root" to be used as fallback
    "root": {
      weekLetter:"W",
      sizeunit:{
        "B":" B",
        "KB":" KB",
        "MB":" MB",
        "GB":" GB",
        "TB":" TB"
      },
      units:rootUnits
    },
    "fr": {
      weekLetter:"S",
      sizeunit: {
        "B": "o",
        "KB": "Ko",
        "MB": "Mo",
        "GB": "Go",
        "TB": "To"
      },
      units:frUnits
    },
    "es": {
      weekLetter:"S",
      units:esUnits
    },
    "de": {
      weekLetter:"W",
      units:deUnits
    },
    "pt": {
      weekLetter:"S",
      units:ptUnits
    },
    "sq": {
      weekLetter:"J"
    },
    "nl": {
      weekLetter:"W",
      units:nlUnits
    },
    "it":{
      weekLetter:"S",
      units:itUnits
    },
    "ja":{
      weekLetter:"週"
    },
    "ru":{
      weekLetter:"н",
      sizeunit: {
        "B": " Б",
        "KB": " КБ",
        "MB": " МБ",
        "GB": " ГБ",
        "TB": " ТБ"
      }
    },
    "ko":{
      weekLetter:"주"
    },
    "sv":{
      weekLetter:"V",
      units:svUnits
    }

  }

